import React from 'react'
import { PlaylistsGrid } from './PlaylistsGrid'
import { PlaylistsCarousel } from './PlaylistsCarousel'
import 'flickity/dist/flickity.min.css';
import { useHistory } from "react-router-dom";
import isElectron from "is-electron";
import { connect } from "react-redux";
import { setSearchString } from "../../../actions/search";
import { useMatomo } from "@datapunt/matomo-tracker-react";


const PlaylistsViewWrapper = ( props ) => {
    const seeAllPlaylist = process.env.REACT_APP_ALL_PLAYLIST_ON_HOME === "1" ?? false;
    const { type, items } = props;
    const history = useHistory ();
    const { pushInstruction } = useMatomo ();

    const handleClick = ( data ) => {
        const { type, id, title } = data;
        const application = isElectron () ? "- Desktop" : "- Web"
        switch ( type ) {
            case "search":
                props.setSearchString ( encodeURIComponent ( title ).split ( "%20" ).join ( " " ) );
                pushInstruction ( 'setUserId', props.session.user );
                // pushInstruction ( "setDocumentTitle", "Search from PlaylistGroup");
                pushInstruction ( 'setCustomUrl', isElectron () ? process.env.REACT_APP_SITE_URL + window.location.pathname : window.location.href );
                pushInstruction ( 'trackEvent', 'WDOCS ' + application, 'click on searchbox', title );
                pushInstruction ( 'trackPageView' );
                history.push ( "/search/" + title );
                break;
            case "playlist":
            default:
                pushInstruction ( 'setUserId', props.session.user );
                pushInstruction ( "setDocumentTitle", "Playlist from Playlist Group" );
                pushInstruction ( 'setCustomUrl', isElectron () ? process.env.REACT_APP_SITE_URL + window.location.pathname : window.location.href );
                pushInstruction ( 'trackEvent', 'WDOCS ' + application, 'click on playlistgroup', id + " " + title );
                pushInstruction ( 'trackPageView' );
                history.push ( "/playlist/" + id );
                break;
        }
    }

    return (
        <div>
            {seeAllPlaylist ? <PlaylistsGrid
                type={type}
                items={items}
                handleClick={ handleClick }
            /> : < PlaylistsCarousel
                    type={type}
                    items={items}
                    handleClick={ handleClick }
                />
            }
        </div>
    )
}
const mapStateToProps = ( state ) => ( {
    session: state.session,
} )

export default connect ( mapStateToProps, {
    setSearchString
} ) ( PlaylistsViewWrapper );
